import React from 'react';
import { useHistory } from 'react-router-dom';
import { Icon, Title, Space, Button } from 'components';
import styled from 'styled-components';
import { useBreakpoint } from 'hooks';
import ShowingDropdown from './ShowingsDropdown';
import { useShowingsCalendarContext } from '../ShowingsCalendarContext';
import ListingImage from '../Tables/components/ListingImage';

const ShowingHeader: React.FC = () => {
  const history = useHistory();
  const { md } = useBreakpoint();
  const context = useShowingsCalendarContext();
  const { calendarType, listing, listingId } = context;
  const isListingCalendar = calendarType === 'listing';
  const showExtraHeader = isListingCalendar && !md;
  const headerTitle = isListingCalendar ? (
    <Space size={12}>
      <button onClick={history.goBack}>
        <Icon type="arrowLeftThin" color="black" offset={[0, 2]} />
      </button>
      {md && <ListingImage thumbnail={listing.thumbnail} />}
      <StyledTitle level={md ? 1 : 3}>
        {listing.line1} {listing.line2 || ''}
      </StyledTitle>
    </Space>
  ) : (
    <Title level={1} hideMargin data-cy="showings-calendar-title">
      Showings
    </Title>
  );

  const headerExtra = (
    <div>
      <ShowingDropdown />
      <Button
        ghost
        icon={<Icon type="settings" color="black" />}
        href={`#/listing/${listingId}/appointments/config`}
        data-cy="showing-config-button"
      />
    </div>
  );

  return (
    <StyledPageHeader>
      <div>
        <Space wrap>{headerTitle}</Space>
      </div>
      {showExtraHeader && headerExtra}
    </StyledPageHeader>
  );
};

const StyledTitle = styled(Title)`
  margin: 0 !important;
`;

const StyledPageHeader = styled.div`
  width: 100%;
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin: 0;
  padding: 0;
  h1 {
    display: inline;
  }
`;

export default ShowingHeader;
